import Link from "next/link";
import { ChevronRight } from "lucide-react";

import { cn } from "@/lib/utils";
import type { BreadcrumbItem } from "@/lib/seo/schema";

const Breadcrumbs = ({ items, className }: { items: BreadcrumbItem[]; className?: string }) => {
  if (items.length < 2) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className={cn(
        "mx-auto flex w-full max-w-screen-2xl items-center gap-1.5 px-4 pt-6 text-[12px] text-[#8B93A7] md:px-12 lg:px-[120px]",
        className,
      )}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span key={item.href} className="flex items-center gap-1.5">
            {index > 0 && <ChevronRight className="size-3" strokeWidth={2.5} aria-hidden />}
            {isLast ? (
              <span className="font-medium text-crayoBlue">{item.name}</span>
            ) : (
              <Link
                href={item.href}
                prefetch={false}
                className="transition-colors hover:text-crayoBlue"
              >
                {item.name}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
